import { isMobile } from 'react-device-detect';
import { IS_HML_VERSION } from '../constants/hml_variable';

/**
 * @param {'budget' | 'os'} kind
 * @param {string} encodedId
 */
export const buildExternalUrl = (kind, encodedId) => {
  const path = kind === 'os' ? 'external-os' : 'external-budget';
  const isLocal = window.location.hostname === 'localhost';
  if (isLocal) return `http://localhost:3000/${path}/${encodedId}`;
  const subdomain = IS_HML_VERSION ? 'homolog.' : '';
  return `https://${subdomain}prospera.app.br/${path}/${encodedId}`;
};

// Monta o universal link oficial do WhatsApp. wa.me abre o app no mobile
// (quando instalado) e a versão web no desktop.
export const buildWaMeUrl = ({ phone, message, countryCode = '55' }) => {
  const digits = String(phone).replace(/\D/g, '');
  const withCountry = digits.startsWith(countryCode)
    ? digits
    : `${countryCode}${digits}`;
  return `https://wa.me/${withCountry}?text=${encodeURIComponent(message)}`;
};

// Deve ser chamada sincronamente dentro do handler do click, sem aguardar
// promises antes — caso contrário o iOS/Android perde a "transient user
// activation" e o universal link não dispara o app, caindo no web.whatsapp.
export const openWhatsapp = (url) => {
  if (isMobile) {
    window.location.href = url;
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};
